import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '../../utils';
export function FormGridItem({ children, gap, rowGap, align, endDecorator = true, }) {
    return (_jsx(FormGridItemRootStyled, { align: align, children: _jsx(FormGridItemStyled, { gap: gap, rowGap: rowGap, endDecorator: endDecorator, children: children }) }));
}
const FormGridItemRootStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'align',
    name: 'FormGridItemRootStyled',
})(({ align }) => ({
    display: 'grid',
    alignItems: align ? align : 'flex-start',
}));
const FormGridItemStyled = styled('div', {
    shouldForwardProp: (prop) => prop !== 'gap' && prop !== 'rowGap' && prop !== 'endDecorator',
    name: 'FormGridItemStyled',
})(({ theme, gap, endDecorator, rowGap }) => ({
    display: rowGap ? 'grid' : '',
    rowGap: theme.spacing(rowGap ? rowGap : 0),
    '&:not(:empty)': {
        paddingBottom: gap ? theme.spacing(gap) : 'unset',
    },
    paddingRight: endDecorator ? '45px' : 'unset',
}));
